import { ERoutePaths as EPath } from '../types/navigation';

const NEW_FAMILY_ACCOUNT = 'new/family';
const NEW_BUSINESS_ACCOUNT = 'new/business';
const DASHBOARD = 'dashboard';

const CLIENT = 'client';

const MERGE_CUSTOMER = 'merge/customer';

export const CUSTOMERS_MODULE_PATH = `/${CLIENT}/${EPath.CUSTOMERS}`;

const getInvoicePaymentPath = (customerId: number) => `${EPath.CUSTOMER}/${customerId}/${EPath.PAYMENTS}`;
const getCustomerPagePath = (customerId: number) => `/${EPath.CUSTOMER}/${customerId}/${EPath.OVERVIEW}`;

const getFullCustomerPagePath = (customerId: number) =>
	`${CUSTOMERS_MODULE_PATH}#${getCustomerPagePath(customerId)}`;

/**
 * Full Backoffice reservation overview URL for new-tab navigation.
 */
export const getFullReservationPagePath = (reservationId: number): string =>
	`/${CLIENT}/${EPath.RESERVATIONS}#/${EPath.RESERVATION}/${EPath.OVERVIEW}/${reservationId}`;

const getFamilyPagePath = ({
	familyId,
	isLeadingSlash = true,
}: {
	familyId: number | string;
	isLeadingSlash?: boolean;
}) => `${isLeadingSlash ? '/' : ''}${EPath.FAMILY}/${familyId}/${EPath.OVERVIEW}`;

export {
	getInvoicePaymentPath,
	getCustomerPagePath,
	getFamilyPagePath,
	NEW_FAMILY_ACCOUNT,
	NEW_BUSINESS_ACCOUNT,
	getFullCustomerPagePath,
	CLIENT,
};

export const getMembershipByIdPath = (id: number) => `${DASHBOARD}/${id}`;

export const getFullMembershipDashboardPath = (membershipId: number) =>
	`/${CLIENT}/${EPath.MEMBERSHIPS}#/${getMembershipByIdPath(membershipId)}`;

export const getFullMembershipMembersPath = (membershipId: number) =>
	`/${CLIENT}/${EPath.MEMBERSHIPS}#/${getMembershipByIdPath(membershipId)}?tab=members`;

export const getInvoiceByIdPath = (id: number, param?: string) =>
	`${EPath.INVOICES}/${id}/${EPath.DETAILS}${param ? '?' : ''}${param || ''}`;

export const getCustomerInvoiceDetailsHash = (customerId: number, invoiceId: number): string =>
	`#/${EPath.CUSTOMER}/${customerId}/${EPath.INVOICES}/${invoiceId}/${EPath.DETAILS}`;

export const getCustomerInvoiceDetailsPath = (customerId: number, invoiceId: number): string =>
	`${CUSTOMERS_MODULE_PATH}${getCustomerInvoiceDetailsHash(customerId, invoiceId)}`;

export const getMergeCustomersPath = (customerId?: number) =>
	customerId ? `/${MERGE_CUSTOMER}/${customerId}` : `/${MERGE_CUSTOMER}`;
